const $ = require('jquery');

export default {
  init() {
    $('.accordeon__head').on('click', (e: any) => {
      $(e.currentTarget).toggleClass('is-active');
      $(e.currentTarget)
        .next()
        .slideToggle();
    });
  }
};
